import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import FloatingGallery from "components/Web_User_Interface/1440p_Series/Features/Wizard/WizardGallery";
export const _frontmatter = {
  "title": "Features Menü // Wizard",
  "path": "/Web_User_Interface/1440p_Serie/Features/Wizard/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Installation Wizard.",
  "image": "./WebUI_1440p_SearchThumb_Features_Status_LEDs.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features_Status_LEDs.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='Features Menü // Wizard' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Installation Wizard.' image='/images/Search/WebUI_1440p_SearchThumb_Features_Status_LEDs.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Features_Status_LEDs.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Features/Wizard/' locationFR='/fr/Web_User_Interface/1440p_Series/Features/Wizard/' crumbLabel="Wizard" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "wizard",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#wizard",
        "aria-label": "wizard permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Wizard`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/6b5cf24d78069abda1696cacb322349a/d53ff/1440p_Settings_Features_Wizard.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.39130434782609%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACFElEQVQoz1WQ3UtTcRyH93d4ZdHG5l4ujGruvJ+dc7aznbOdt21uQaj0ohYRKGqaCysJ8apbIUKhyEC9KihCSUTospv+nSfOISkvHj6/q4fn+0uVSiUKhQKFQpFs+gpyfwn/xTec1QPctSPcZ0c0V4+wlg+prRwmW185YLD1HXnwFFkoUyiWGBkZYXR0lNTY2Bgx+Xye9LWraM0e/cev6M6u05sb0psfJtude040OyR6sE7n/hr9RxvY0QyVCYGJssj18ZuMj98gFYsuSGcyKGKFbuAStptE3gUOoWvh1VXaTYNGy6bZsnFsG1k0kCUdVTERBfVfYUw6nUbVNLq9SfwgxPMj/DDC9zzCmQU6C2+4M73Ipu3w0vUJmyGGbqKpeiKtTMikcrlcUhcLM5kM5XKZet2m5bp0Og7ttovvOQSDaVpTCwwGMywFLZbdFg9v+3QiA01RkSQdofJXGMvijYml2WwORVLp93SiQMcydCxdQi7folETMRsC8/d6bA/7dAIBVdbQFA1R+E94QTabpVgsoUhVapZJ4JtYhoZpVNE1Dc9psLG2yOnxVz7vvCa0xaTQqqqIgnT55PgdC/P5ArKkoakGNctAECQmwzZbG0vsvNvj5/kJv85O+P3hPU+6LrIsUVU1KhXpcuH/QkXWE8yqwVTX59PONvu7bzk9+8H5l32OP+5xvL/L5l2fmqEkAfEf/gHUblbdE0u5XQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/6b5cf24d78069abda1696cacb322349a/e4706/1440p_Settings_Features_Wizard.avif 230w", "/de/static/6b5cf24d78069abda1696cacb322349a/d1af7/1440p_Settings_Features_Wizard.avif 460w", "/de/static/6b5cf24d78069abda1696cacb322349a/7f308/1440p_Settings_Features_Wizard.avif 920w", "/de/static/6b5cf24d78069abda1696cacb322349a/ca993/1440p_Settings_Features_Wizard.avif 1068w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/6b5cf24d78069abda1696cacb322349a/a0b58/1440p_Settings_Features_Wizard.webp 230w", "/de/static/6b5cf24d78069abda1696cacb322349a/bc10c/1440p_Settings_Features_Wizard.webp 460w", "/de/static/6b5cf24d78069abda1696cacb322349a/966d8/1440p_Settings_Features_Wizard.webp 920w", "/de/static/6b5cf24d78069abda1696cacb322349a/55b8e/1440p_Settings_Features_Wizard.webp 1068w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/6b5cf24d78069abda1696cacb322349a/81c8e/1440p_Settings_Features_Wizard.png 230w", "/de/static/6b5cf24d78069abda1696cacb322349a/08a84/1440p_Settings_Features_Wizard.png 460w", "/de/static/6b5cf24d78069abda1696cacb322349a/c0255/1440p_Settings_Features_Wizard.png 920w", "/de/static/6b5cf24d78069abda1696cacb322349a/d53ff/1440p_Settings_Features_Wizard.png 1068w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/6b5cf24d78069abda1696cacb322349a/c0255/1440p_Settings_Features_Wizard.png",
              "alt": "Web User Interface - 1440p Series - Features Status LED",
              "title": "Web User Interface - 1440p Series - Features Status LED",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <FloatingGallery mdxType="FloatingGallery" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      